export const desktopAppDataHooks = {
  toolBar: 'tool-bar',
  templateDemo: 'template-demo',
  infoPopUp: 'info-pop-up',
  wixStudioToolbar: 'wix-studio-toolbar',
  wixStudioNewToolbar: 'wix-studio-new-toolbar',
  wixStudioTemplateDemo: 'wix-studio-template-demo',
};
